export interface ILessonFolder {
    id: string;
    name: string;
    dateCreated: string;
    dateUpdated: string;
    teacher?: {
        id: string;
    };
    shares?: {
        id: string;
    }[];
}

export class LessonFolder implements ILessonFolder {
    readonly id: string;
    readonly name: string;
    readonly dateCreated: string;
    readonly dateUpdated: string;
    readonly teacher?: {
        id: string;
    };
    readonly shares?: {
        id: string;
    }[];

    constructor(cl: ILessonFolder) {
        this.id = cl.id;
        this.name = cl.name;
        this.dateCreated = cl.dateCreated;
        this.dateUpdated = cl.dateUpdated;
        this.teacher = cl.teacher;
        this.shares = cl.shares;
    }

    isOwnedBy(profile: { id: string }) {
        return this.teacher?.id === profile.id;
    }

    isShared() {
        return (this.shares && this.shares.length > 0) ?? false;
    }

    isSharedWithMe(profile: { id: string }) {
        return this.teacher?.id !== profile.id;
    }
}
